<template>
  <v-app>
    <rec-header></rec-header>

    <v-main>
      <router-view> </router-view>
    </v-main>

    <rec-footer></rec-footer>
  </v-app>
</template>

<script>
import RecHeader from '@/components/common/RecHeader';
import RecFooter from '@/components/common/RecFooter.vue';

export default {
  name: 'App',
  components: {
    'rec-header': RecHeader,
    'rec-footer': RecFooter,
  },

  data() {
    return {
      isModalOpen: false,
      modalURL:
        'https://hrchat.workup.plus/workup-aiagent-chatbot-admin/recruitModelTest',
    };
  },

  computed: {
    shouldShowModal() {
      // 페이지 URL에 "harim"이라는 문자열이 포함되어 있는지 확인합니다.
      return window.location.href.includes('harim');
    },
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
  },
};
</script>

<style scoped>
.modal-wrapper {
  position: fixed;

  margin-top: 0;
  margin-bottom: 0;

  bottom: 90px;
  right: 0;
  width: 20%; /* 모달의 너비 설정 */

  background-color: white;
  border: 1px solid #ccc;
  z-index: 1000;
}
.sticky {
  position: fixed;
  top: 75%;
  right: 40%;
  opacity: 1;
  margin: 0 -580px 0 0;
  transition: opacity 0.3s;
  &:hover {
    opacity: 1;
  }
}

.modal-content {
}

/* iframe {
  width: 100%;
  height: 100%;
  border: none;
} */
</style>
